const DIGITAL_WORKER_PROJECT_NAME = 'ai-studio';
const DIGITAL_WORKER_PIPELINE_DESCRIPTION_PREFIX =
  'AI Generated - Session ID - ';

export const isDigitalWorkerProject = (projectName?: string | null): boolean =>
  projectName === DIGITAL_WORKER_PROJECT_NAME;

export const isDigitalWorkerPipeline = (
  pipelineDescription?: string | null
): boolean =>
  Boolean(
    pipelineDescription?.startsWith(DIGITAL_WORKER_PIPELINE_DESCRIPTION_PREFIX)
  );
